import React from 'react';
import { Link } from 'react-router-dom';

const LayoutMenu = ({ userId }) => {
    return (
        <nav className="navbar navbar-expand-lg navbar-light" style={{ backgroundColor: '#27355c' }}>
            <div className="container">
                <a className="navbar-brand" href="/">
                    <img src="/coworking-itaguai-1.png" alt="Your Logo" width="180" />
                </a>
                <button
                    className="navbar-toggler"
                    type="button"
                    data-toggle="collapse"
                    data-target="#navbarNav"
                    aria-controls="navbarNav"
                    aria-expanded="false"
                    aria-label="Toggle navigation"
                >
                    <span className="navbar-toggler-icon"></span>
                </button>
                <div className="collapse navbar-collapse" id="navbarNav">
                    <ul className="navbar-nav">
                        <li className="nav-item">
                            <Link to="/agenda" className="nav-link" style={{ color: 'white' }}>
                                Agenda
                            </Link>
                        </li>
                        <li className="nav-item">
                            <Link to="/clientes" className="nav-link" style={{ color: 'white' }}>
                                Clientes
                            </Link>
                        </li>
                        <li className="nav-item">
                            <Link to="/agendamentos" className="nav-link" style={{ color: 'white' }}>
                                Agendamentos
                            </Link>
                        </li>
                        <li className="nav-item">
                            <Link to="/faturas" className="nav-link" style={{ color: 'white' }}>
                                Faturas
                            </Link>
                        </li>
                        <li className="nav-item">
                            <Link to="/pagamentos" className="nav-link" style={{ color: 'white' }}>
                                Pagamentos
                            </Link>
                        </li>
                        {/*<li className="nav-item">
                            <a className="nav-link" href="/" style={{ color: 'white' }}>
                                Mensalistas
                            </a>
                        </li>*/}
                        <li className="nav-item dropdown">
                            <button className="nav-link dropdown-toggle" id="relatoriosDropdown" data-bs-toggle="dropdown" aria-expanded="false" style={{ color: 'white', background: 'none', border: 'none' }}>
                                Relatórios
                            </button>
                            <ul className="dropdown-menu" aria-labelledby="relatoriosDropdown">
                                <li>
                                    <Link className="dropdown-item" to="/relatorios/faturas">Faturas</Link>
                                </li>
                                <li>
                                    <Link className="dropdown-item" to="/relatorios/faturas-canceladas">Faturas Canceladas</Link>
                                </li>
                                <li>
                                    <Link className="dropdown-item" to="/relatorios/financeiro">Financeiro Entradas</Link>
                                </li>
                                <li>
                                    <Link className="dropdown-item" to="/relatorios/financeiro-extorno">Financeiro Extornos</Link>
                                </li>
                                <li>
                                    <Link className="dropdown-item" to="/relatorios/aniversario">Aniversários</Link>
                                </li>
                            </ul>
                        </li>
                        <li className="nav-item">
                            <Link to="/itens" className="nav-link" style={{ color: 'white' }}>
                                Itens
                            </Link>
                        </li>
                        {userId === 83 && (
                            <li className="nav-item">
                                <Link to="/logs" className="nav-link" style={{ color: 'white' }}>
                                    📋 Logs
                                </Link>
                            </li>
                        )}
                    </ul>
                </div>
            </div>
        </nav>
    );
};

export default LayoutMenu;
